// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__wMvum","box":"WorkspacesBox_box__6J9WD","node":"WorkspacesBox_node__gNjZO"};